import * as actionTypes from "./actionTypes";

export const actions = {
  updateUserQuery: (payload) => ({
    type: actionTypes.SET_USER_QUERY,
    payload,
  }),
  updateOrderId: (payload) => ({
    type: actionTypes.SET_ORDER_ID,
    payload,
  }),
  submitUserComment: (payload) => ({
    type: actionTypes.SUBMIT_COMMENT,
    payload,
  }),
  resetSupportTicketPayload: () => ({
    type: actionTypes.RESET_SUPPORT_TICKET_PAYLOAD,
  }),
  updateSupportTicketPayload: (data) => ({
    type: actionTypes.UPDATE_SUPPORT_TICKET_PAYLOAD,
    data,
  }),
  showCreateTicketModal: (data) => ({
    type: actionTypes.SHOW_CREATE_TICKET,
    data,
  }),
  setTopLevelScreen: (key) => ({
    type: actionTypes.SET_TOP_LEVEL_KEY,
    data: { key },
  }),
  getSupportConfigs: () => ({
    type: actionTypes.GET_SUPPORT_CONFIGS,
  }),
  setSupportConfigs: (payload) => ({
    type: actionTypes.SET_SUPPORT_CONFIGS,
    payload,
  }),
  setDissatReasons: (payload) => ({
    type: actionTypes.SET_DISSAT_REASONS,
    payload,
  }),
};

const initialState = {
  userQuery: "",
  order: [],
  userComment: "",
  ticketPayload: [],
  showDialog: false,
  ticketId: null,
  supportConfig: {},
  supportTickets: [],
  clTicketDisSatisfactionReasons: [],
  message: "",
  buttonText1: "",
  buttonText2: "",
  endingMessage: "",
  buttonText2Color: "",
};

const getUpdatedPayload = (state, data) => {
  const { ticketPayload } = state;
  const key = data && data.dataKey;
  const dataIndex = ticketPayload.findIndex(
    (dataObj) => dataObj.dataKey === key,
  );

  if (dataIndex === -1) {
    return [...ticketPayload, data];
  } else {
    ticketPayload.splice(dataIndex, 1, data);
    return ticketPayload.slice(0, dataIndex + 1);
  }
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SET_USER_QUERY:
      return {
        ...state,
        userQuery: action.payload,
      };
    case actionTypes.SET_ORDER_ID:
      return {
        ...state,
        order: action.payload,
      };
    case actionTypes.SUBMIT_COMMENT:
      return {
        ...state,
        userComment: action.payload,
      };
    case actionTypes.RESET_SUPPORT_TICKET_PAYLOAD:
      return {
        ...state,
        ticketPayload: [],
      };
    case actionTypes.UPDATE_SUPPORT_TICKET_PAYLOAD: {
      const ticketPayload = getUpdatedPayload(state, action.data);
      return {
        ...state,
        ticketPayload,
      };
    }
    case actionTypes.SHOW_CREATE_TICKET:
      const { data = {} } = action;
      return {
        ...state,
        showDialog: data?.show,
        ticketId: data?.id,
        message: data?.message,
        buttonText1: data?.buttonText1,
        buttonText2: data?.buttonText2,
        endingMessage: data?.endingMessage,
        buttonText2Color: data?.buttonText2Color,
      };

    case actionTypes.SET_TOP_LEVEL_KEY:
      return {
        ...state,
        topLevelKey: action.data.key,
      };

    case actionTypes.SET_SUPPORT_CONFIGS:
      return {
        ...state,
        supportConfig: action.payload.config,
        supportTickets: action.payload.tickets,
      };

    case actionTypes.SET_DISSAT_REASONS:
      return {
        ...state,
        clTicketDisSatisfactionReasons: action.payload,
      };

    default:
      return state;
  }
}
reducer.initialState = initialState;

export default reducer;
